<ng-container [ngSwitch]="view">
  <!-- Reset Form -->
  <div *ngSwitchCase="'reset'">
    <div class="text-18 text-semibold text-center mt-2 mb-8" data-test="infoText">Forgot your password?</div>

    <p class="text-12 text-semibold text-center mt-6 mb-6" data-test="infoText1">
        Don't worry - we'll email you instructions to <br> reset your password.
    </p>
    
    <form (submit)="handleSubmit()" [formGroup]="form">
      <app-form-field label="Email" data-test="emailLabel">
        <input
          class="input w-100"
          data-test="emailInput"
          name="email"
          type="email"
          formControlName="email"
          placeholder="Email">
      </app-form-field>
      
      <app-form-field>
        <button
          app-button
          buttonType="primary"
          buttonSize="medium"
          class="w-100"
          [disabled]="loading$ | async"
          type="submit">
          <span *ngIf="!(loading$ | async)" data-test="resetPasswordButton">Reset Password</span>
          <app-spinner size="medium" *ngIf="loading$ | async"></app-spinner>
        </button>
      </app-form-field>
    </form>
  </div>

  <!-- Success Message -->
  <div *ngSwitchCase="'success'">
    <p class="text-12 text-semibold text-center mt-6 mb-6" data-test="successText">
        We sent instructions for resetting your account password to {{ email }}
    </p>
  </div>

  <div class="mt-4">
    <button
      app-button
      type="button"
      buttonTheme="light"
      [uppercase]="false"
      class="w-100"
      [routerLink]="['/login']"
      data-test="backToSignInButton">Back to sign in</button>
  </div>
</ng-container>

